import { createFilterOptions, FilterOptionsState } from '@lyearn/ui';
import { SelectFieldOptionsType } from '@/types/schema';

const filter = createFilterOptions<SelectFieldOptionsType>();

export const ADD_OPTION_ID = 'ADD_OPTION_ID';

const getFilteredOptions =
  (color: string) =>
  (options: SelectFieldOptionsType[], params: FilterOptionsState<SelectFieldOptionsType>) => {
    const filtered = filter(options, params);
    if (params.inputValue !== '') {
      filtered.push({
        color,
        optionId: ADD_OPTION_ID,
        value: params.inputValue,
      });
    }
    return filtered;
  };

export default getFilteredOptions;
